import { Injectable } from "@angular/core";
import { DataService } from "@app/core";
import {
  CompleteQuickSetupModel,
  CreateManagerAccountResponseDto,
  QuickSetupChecklist,
  QuickSetupConfiguration
} from "@app/models";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class QuickSetupService {
  private serviceUrl = "QuickSetup";

  constructor(private http: DataService) {}

  createAccount(quickSetupModel: CompleteQuickSetupModel): Observable<CreateManagerAccountResponseDto> {
    return this.http.post(`${this.serviceUrl}/createAccount`, quickSetupModel);
  }

  getChecklist(locationId: number): Observable<QuickSetupChecklist> {
    return this.http.get(`${this.serviceUrl}/getchecklist/${locationId}`);
  }

  updateChecklist(locationId: number, checklist: QuickSetupChecklist): Observable<QuickSetupChecklist> {
    return this.http.post(`${this.serviceUrl}/updatechecklist/${locationId}`, checklist);
  }

  doneQuickSetup(): Observable<boolean> {
    return this.http.post(`${this.serviceUrl}/doneQuickSetup`);
  }

  getConfiguration(): Observable<QuickSetupConfiguration> {
    return this.http.get(`${this.serviceUrl}/configuration`);
  }

  resetAccount(): Observable<boolean> {
    return this.http.post(`${this.serviceUrl}/resetAccount`);
  }
}
